import { render, staticRenderFns } from "./modal-login.vue?vue&type=template&id=fb0641ac&scoped=true&"
import script from "./modal-login.vue?vue&type=script&lang=js&"
export * from "./modal-login.vue?vue&type=script&lang=js&"
import style0 from "./modal-login.vue?vue&type=style&index=0&id=fb0641ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0641ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb0641ac')) {
      api.createRecord('fb0641ac', component.options)
    } else {
      api.reload('fb0641ac', component.options)
    }
    module.hot.accept("./modal-login.vue?vue&type=template&id=fb0641ac&scoped=true&", function () {
      api.rerender('fb0641ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/modals/modal-login.vue"
export default component.exports